/**
 * Exit the current offer flow through its website back link.
 */
export function useFlowExit() {
    const route = useRoute();
    const sessionStore = useSessionStore();
    const { openConfirmDialog } = useConfirmActionDialog();
    const { t: $t } = useNuxtApp().$i18n;

    const isOfferFlow = computed(() => (getRouteName(route) ?? '').startsWith('offerFlow'));
    const backLink = computed(() => isOfferFlow.value ? sessionStore.backLink : undefined);
    const isCloseVisible = computed(() => !!backLink.value);

    function leaveToBackLink() {
        const url = backLink.value;
        if (!url) {
            return;
        }
        openConfirmDialog(
            $t('core.confirmLeaveDialog.heading'),
            $t('core.confirmLeaveDialog.body'),
            () => navigateTo(url, { external: true }),
            $t('core.confirmLeaveDialog.confirmLabel'),
            () => {},
            $t('core.confirmLeaveDialog.cancelLabel'),
        );
    }

    return {
        backLink,
        isCloseVisible,
        leaveToBackLink,
    };
}
